import { TextField } from '@mui/material';
import { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';

export const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
      allowNegative={false}
      decimalScale={2}
      fixedDecimalScale={true}
      prefix="$"
    />
  );
});

export default function CurrencyFormField(props) {
  return (
    <TextField
      {...props}
      InputProps={{
        inputComponent: NumericFormatCustom,
      }}
    />
  );
}
